import { useState } from "react";

const Tooltip = ({ children }) => (
  <div className="nav-item__tooltip">
    <div>{children}</div>
  </div>
);

const NavItem = ({ skill, onHover, index, className }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
    onHover(index, true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    onHover(index, false);
  };

  return (
    <li
      className={`nav-item ${isHovered ? "hover" : ""} ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="nav-item__link">
        {" "}
        {/* Changed from <a> to <div> */}
        <img
          src={skill.icon}
          alt={`${skill.name} icon`}
          className="nav-item__image"
          loading="eager"
        />
      </div>
      <Tooltip>{skill.name}</Tooltip>
    </li>
  );
};

const Row = ({ skills, startIndex }) => {
  const [hoveredStates, setHoveredStates] = useState(
    new Array(skills.length).fill(false)
  );

  const handleHover = (index, isHovered) => {
    const rowIndex = index - startIndex;
    setHoveredStates((prev) => {
      const newStates = [...prev];
      newStates[rowIndex] = isHovered;
      return newStates;
    });
  };

  return (
    <div className="nav-row">
      {skills.map((skill, index) => {
        const actualIndex = startIndex + index;
        const rowIndex = index;

        const isSiblingClose =
          (hoveredStates[rowIndex - 1] || hoveredStates[rowIndex + 1]) &&
          !hoveredStates[rowIndex];
        const isSiblingFar =
          (hoveredStates[rowIndex - 2] || hoveredStates[rowIndex + 2]) &&
          !hoveredStates[rowIndex] &&
          !hoveredStates[rowIndex - 1] &&
          !hoveredStates[rowIndex + 1];

        return (
          <NavItem
            key={skill.name}
            skill={skill}
            index={actualIndex}
            onHover={handleHover}
            className={`
              ${isSiblingClose ? "sibling-close" : ""}
              ${isSiblingFar ? "sibling-far" : ""}
            `}
          />
        );
      })}
    </div>
  );
};

const SkillsNav = ({ skills }) => {
  const firstRowSkills = skills.slice(0, Math.ceil(skills.length / 2));
  const secondRowSkills = skills.slice(Math.ceil(skills.length / 2));

  return (
    <nav className="nav-bar">
      <ul className="nav-list">
        <Row skills={firstRowSkills} startIndex={0} />
        <Row skills={secondRowSkills} startIndex={firstRowSkills.length} />
      </ul>
    </nav>
  );
};

export default SkillsNav;
